import accordionSummaryClasses from "@mui/material/AccordionSummary/accordionSummaryClasses";
export const MuiAccordionSummaryTheme = (dt) => {
    return {
        defaultProps: {},
        styleOverrides: {
            root: {
                [`&.Mui-expanded .${accordionSummaryClasses.content}`]: {
                    margin: 0,
                },
                '.PixelIcon:not([class*="MuiSvgIcon-color"])': {
                    backgroundColor: dt.color.onSurface.variant,
                },
            },
        },
    };
};
